import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'portfolio.dashboard.header',
    description: 'Vertical header title for reports brochure section',
    defaultMessage: 'Maksulliset ominaisuudet',
  },
  companyInfoMissing: {
    id: 'portfolio.dashboard.companyInfoMissing',
    description: 'Vertical header title for reports brochure section',
    defaultMessage:
      'Yrityksen tiedot puuttuvat. Pääset päivittämään tiedot menemällä ensin muokkaustilaan.',
  },
  chooseThemeLabel: {
    id: 'portfolio.dashboard.chooseThemeLabel',
    description: 'Label for choosing brochure theme',
    defaultMessage: 'Valitse teema',
  },
  addCompanyLogo: {
    id: 'portfolio.dashboard.addCompanyLogo',
    description: 'Add company logo',
    defaultMessage: 'Lisää logo',
  },
  companyInfoLabel: {
    id: 'portfolio.dashboard.companyInfoLabel',
    description: 'Info about the company label',
    defaultMessage: 'Tietoa yrityksestä',
  },
  noSlideTitle: {
    id: 'portfolio.dashboard.noSlideTitle',
    description: 'Slide has no title',
    defaultMessage: 'Sivulla ei ole otsikkoa',
  },
  noSlideContent: {
    id: 'portfolio.dashboard.noSlideContent',
    description: 'Slide has no text content',
    defaultMessage: 'Sivulla ei ole tekstisisältöä',
  },
  guideText: {
    id: 'portfolio.dashboard.guideText',
    description: 'Guide text for adding brochure pages',
    defaultMessage: 'Lisää kortteja',
  },
  guideTextOrdering: {
    id: 'portfolio.dashboard.guideTextOrdering',
    description: 'Guide text for ordering brochure pages',
    defaultMessage: 'Muuta korttien järjestystä vetämällä hiirellä.',
  },
  noSlidesAndEdit: {
    id: 'portfolio.dashboard.noSlidesAndEdit',
    description: 'When user has no pages and is in edit mode',
    defaultMessage: 'Add cards',
  },
  noSlidesAndNoEdit: {
    id: 'portfolio.dashboard.noSlidesAndNoEdit',
    description: 'When user has no pages and is not in edit mode',
    defaultMessage: 'Go to edit mode and add cards',
  },
  addImage: {
    id: 'portfolio.dashboard.addImage',
    description: 'Add image to the brochure page',
    defaultMessage: 'Add image',
  },
  removeSlide: {
    id: 'portfolio.dashboard.removeSlide',
    description: 'Remove slide from the brochure',
    defaultMessage: 'Remove slide',
  },
  slideTitleLabel: {
    id: 'portfolio.dashboard.slideTitleLabel',
    description: 'Page title label in edit mode',
    defaultMessage: 'Page title',
  },
  textContentLabel: {
    id: 'portfolio.dashboard.textContentLabel',
    description: 'Page content label in edit mode',
    defaultMessage: 'Page content',
  },
  disabled: {
    id: 'portfolio.dashboard.disabled',
    description: 'A HTML formatted long descripton when brochure is disabled',
    defaultMessage: '<p>Your companys brochure is disabled</p>',
  },
  enablePortfolio: {
    id: 'portfolio.dashboard.enablePortfolio',
    description: 'Button text for the enable portfolio button',
    defaultMessage: 'Enable portfolio',
  },
  disablePortfolio: {
    id: 'portfolio.dashboard.disablePortfolio',
    description: 'Button text for the disable portfolio button',
    defaultMessage: 'Disable portfolio',
  },
  hidePortfolio: {
    id: 'portfolio.dashboard.hidePortfolio',
    description: 'Button text for the hide portfolio button',
    defaultMessage: 'Hide portfolio',
  },
  showPortfolio: {
    id: 'portfolio.dashboard.showPortfolio',
    description: 'Button text for the show portfolio button',
    defaultMessage: 'Show portfolio',
  },
  searchKeywords: {
    id: 'portfolio.dashboard.searchKeywords',
    description: 'Keywords used by the search to find the company',
    defaultMessage: 'Search keywords',
  },
  companyLocalities: {
    id: 'portfolio.dashboard.companyLocalities',
    description: 'Additional municipalities used by the search to find the company',
    defaultMessage: 'Company municipalities',
  },
  companyLocalitiesRemove: {
    id: 'portfolio.dashboard.companyLocalities.remove',
    description: 'Remove company locality',
    defaultMessage: 'Remove locality',
  },
  companyHometown: {
    id: 'portfolio.dashboard.companyHometown',
    description: 'Companys hometown',
    defaultMessage: 'Company hometown',
  },
  hometownMissing: {
    id: 'portfolio.dashboard.hometownMissing',
    description: 'Companys hometown information is missing',
    defaultMessage: 'Hometown info missing',
  },
  companyLocalitiesInfo: {
    id: 'portfolio.dashboard.companyLocalitiesInfo',
    description: 'In addition to the hometown you can choose other municipalities below',
    defaultMessage: 'Company localities info',
  },
  companyLocalitiesWholeCountryLabel: {
    id: 'portfolio.dashboard.companyLocalitiesWholeCountryLabel',
    description: 'The company operates throughout the country',
    defaultMessage: 'Whole country',
  },
  localitySearchDisabledWholeCountry: {
    id: 'locality.search.disabled.wholeCountry',
    description: 'Locality search disabled because company operates throughout the country',
    defaultMessage: 'You can\'t edit localities since you have selected the "whole country"-option.',
  },
  companyLocalitiesWholeRegionLabel: {
    id: 'portfolio.dashboard.companyLocalitiesWholeRegionLabel',
    description: 'The company operates throughout the whole region',
    defaultMessage: 'Whole region',
  },
  brochureThemeArcticLight: {
    id: 'portfolio.dashboard.brochureThemeArcticLight',
    description: 'Arctic light theme for company brochure',
    defaultMessage: 'Arctic light',
  },
  brochureThemeArcticDark: {
    id: 'portfolio.dashboard.brochureThemeArcticDark',
    description: 'Arctic dark theme for company brochure',
    defaultMessage: 'Arctic dark',
  },
  brochureThemeElegant: {
    id: 'portfolio.dashboard.brochureThemeElegant',
    description: 'Elegant theme for company brochure',
    defaultMessage: 'Elegant',
  },
  brochureThemeNavyBlue: {
    id: 'portfolio.dashboard.brochureThemeNavyBlue',
    description: 'Navy blue theme for company brochure',
    defaultMessage: 'Navy blue',
  }
});
